module.exports = __webpack_public_path__ + "static/img/indian-5882632_1280.c462327.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/indian-5882632_1280.webp
// module id = hsg3
// module chunks = 0